module.exports = __webpack_public_path__ + "img/1m1.04b44858.jpg";